import { AbstractControl } from '@angular/forms';
import { regexList } from './regex-list';

export function UsernameValidator(control: AbstractControl): {
  [s: string]: boolean;
} {
  const value = control?.value?.value.trim();
  if (value?.match(regexList.userIdLength)) {
    if (value?.match(regexList.skyMilesNumber)) {
      return <{ [s: string]: boolean }>(<unknown>null);
    } else if (valueMatchCheck(control)) {
      return <{ [s: string]: boolean }>(<unknown>null);
    }
  }
  return { INVALID_LOGIN_CRD: true };
}

function valueMatchCheck(control: AbstractControl): boolean {
  const value = control?.value?.value.trim();
  return value.match(regexList.userName) && value.match(regexList.isNaN);
}
